// import Auth from '../Helpers/auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

async function httpGetAllProducts() {
  try {
    let products = await fetch(`${API_URL}/products`);
    return await products.json();
  } catch (err) {
    return err;
  }
}

async function httpGetProduct(id) {
  try {
    let products = await fetch(`${API_URL}/products/${id}`);
    return await products.json();
  } catch (err) {
    return err;
  }
}

async function httpGetAllSCNProducts() {
  try {
    return await fetch(`${API_URL}/products/scn`);
  } catch (err) {
    return err;
  }
}

export { httpGetAllProducts, httpGetProduct, httpGetAllSCNProducts };
